/*

? The six reactions every client offers (18 Oct 2026), in their order. Kept free of server code so
? the website can import it as well as lib/chat/reactions.ts. The app's copy is REACTION_EMOJIS in
? bbm-android core/utils/chat/ChatReactions.kt; change them together.

*/

export const REACTION_EMOJIS: ReadonlyArray<string> = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

/** One emoji's line in a message's summary, as every reader gets it. */
export type ReactionSummary = { emoji: string; count: number; by_viewer: boolean };

/** [summary] with the viewer's own reaction moved to [emoji] ("" takes it away), for an optimistic update. */
export function withViewerReaction(summary: Array<ReactionSummary>, emoji: string): Array<ReactionSummary> {
	const without: Array<ReactionSummary> = summary.flatMap((line) =>
		!line.by_viewer ? [line] : line.count > 1 ? [{ ...line, count: line.count - 1, by_viewer: false }] : [],
	);
	if (!emoji) return without;
	const at = without.findIndex((line) => line.emoji === emoji);
	if (at >= 0) return without.map((line, i) => (i === at ? { ...line, count: line.count + 1, by_viewer: true } : line));
	return [...without, { emoji, count: 1, by_viewer: true }];
}
